import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environment';

import { RationComponent } from '../../shared/models/models';
import { Measurement, MeasurementSummary } from '../models/measurements.model';

@Injectable({
  providedIn: 'root',
})
export class RuminantsAnalysisService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/ruminants-analysis/secure';

  getMeasurements(): Observable<MeasurementSummary[]> {
    return this.http.get<MeasurementSummary[]>(`${this.baseUrl}/shakerboxmeasurements`);
  }

  getMeasurement(measurementId: number): Observable<Measurement> {
    return this.http.get<Measurement>(`${this.baseUrl}/shakerboxmeasurements/${measurementId}`);
  }

  postMeasurement(measurement: Measurement): Observable<Measurement> {
    return this.http.post<Measurement>(`${this.baseUrl}/shakerboxmeasurements`, measurement);
  }

  updateMeasurement(measurement: Measurement): Observable<Measurement> {
    return this.http.put<Measurement>(
      `${this.baseUrl}/shakerboxmeasurements/${measurement.id}`,
      measurement,
    );
  }

  deleteMeasurement(measurementId: number) {
    return this.http.delete<unknown>(`${this.baseUrl}/shakerboxmeasurements/${measurementId}`);
  }

  getRationComponents() {
    return this.http.get<RationComponent[]>(`${this.baseUrl}/rationcomponents`);
  }

  postCalculate(measurement: Measurement) {
    return this.http.post<Measurement>(
      `${this.baseUrl}/shakerboxmeasurements/calculate`,
      measurement,
    );
  }
}
